import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import H1 from "../h1";
import Button from "../button";
import "./styles.css";
import P from "../p";
import Wrap from "../wrap";

class Banner extends React.PureComponent<> {
  // componentDidMount() {
  //   const desktop = document.getElementById("banner-trustbox-desktop");
  //   const loadFromElement = () => {
  //     if (window.Trustpilot) {
  //       window.Trustpilot.loadFromElement(desktop);
  //     } else {
  //       setTimeout(loadFromElement, 500);
  //     }
  //   };
  //   loadFromElement();
  // }

  render() {
    const { loggedIn, signInWithGoogle, premium } = this.props;

    return (
      <div className="Banner">
        <Wrap>
          <div>
            <P>Keep getting comboed?</P>
            <H1 className="m-top">
              Optimize Your Connection For Minecraft PvP
            </H1>
            <P>
              Use Ghast to give you an edge in Minecraft PvP, it works by
              changing your computers connection settings to the perfect values
              for Minecraft PvP. Thousands of hours have gone into research and
              testing to find the best connection settings possible.
            </P>
            <div style={{ display: "flex" }}>
              <Button
                href={loggedIn ? "#pricing" : undefined}
                onClick={loggedIn ? undefined : signInWithGoogle}
              >
                {loggedIn ? (premium ? "DOWNLOAD" : "BUY NOW") : "GET STARTED"}
              </Button>{" "}
              {/* <div
                id="banner-trustbox-desktop"
                className="trustpilot-widget"
                data-locale="en-GB"
                data-template-id="5419b6ffb0d04a076446a9af"
                data-businessunit-id="5c3cae791aa59c0001976ef2"
                data-style-height="50px"
                data-style-width="200px"
                data-theme="dark"
                data-stars="1,2,3,4,5"
              >
                {" "}
                <a
                  href="https://uk.trustpilot.com/review/ghast.io"
                  target="_blank"
                >
                  Trustpilot
                </a>{" "} 
              </div> */}
            </div>
          </div>
        </Wrap>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({ premium: state.premium });

export default withRouter(connect(mapStateToProps)(Banner));



/** WEBPACK FOOTER **
 ** ./src/views/components/banner/index.js
 **/